'use client'

import { useParams } from 'next/navigation'

import { isPortalAppOnClient } from '../utils/isPortalApp'
import { redirectToPortal } from '../utils/redirectToPortal'

import { usePollEmailVerification } from './usePollEmailVerification'

export function useRefreshEmailVerification() {
  const { locale } = useParams()

  const { isChecking } = usePollEmailVerification({
    onVerified: () => {
      if (!isPortalAppOnClient()) {
        redirectToPortal('', typeof locale === 'string' ? locale : 'en')
      }
    },
  })

  return { isChecking, error: false }
}
